import { type Client, graphql, prefetch } from "@opensea/graphql"
import {
  COLLECTION_OFFERS_SORT,
  COLLECTION_OFFERS_TABLE_PAGE_SIZE,
} from "../constants"
import {
  OfferAggregateTable_collectionFragment,
  OfferAggregateTableFragment,
} from "../OfferAggregateTable/OfferAggregateTable.fragment"

export const CollectionOffersTableQuery = graphql(
  `
    query CollectionOffersTableQuery(
      $collectionSlug: String!
      $filter: CollectionOffersFilter
      $sort: CollectionOfferAggregateSort!
      $cursor: String
      $limit: Int!
    ) {
      collectionOfferAggregates(
        collectionSlug: $collectionSlug
        filter: $filter
        sort: $sort
        cursor: $cursor
        limit: $limit
      ) {
        items {
          id
          totalOffers
          offerPrice {
            token {
              unit
            }
          }
          ...OfferAggregateTable
        }
        nextPageCursor
      }
      collectionBySlug(slug: $collectionSlug) {
        ...OfferAggregateTable_collection
      }
    }
  `,
  [OfferAggregateTable_collectionFragment, OfferAggregateTableFragment],
)

export const prefetchCollectionOffersTableQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionOffersTableQuery, {
    collectionSlug,
    filter: {},
    limit: COLLECTION_OFFERS_TABLE_PAGE_SIZE,
    sort: COLLECTION_OFFERS_SORT,
  })
}
